import { useContext } from 'react';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import AccordionContext from 'react-bootstrap/AccordionContext';

function CustomToggle({ eventKey }) {
  const onClick = useAccordionButton(eventKey);
  const { activeEventKey } = useContext(AccordionContext);
  const isExpanded = activeEventKey === eventKey;

  return (
    <button
      type="button"
      aria-expanded={isExpanded}
      onClick={onClick}
      className={`accordion-button debt-details-toggle${isExpanded ? '' : ' collapsed'}`}
    >
      Repayment details
    </button>
  );
}

export default CustomToggle;